import React from "react"
import styled from "styled-components"
import Container from "../../Container"
import ImageWrapper from "../../ImageWrapper"
import Section from "../../Section"
import TextWrapper from "../../TextWrapper"
import { ListItem, UnorderedList } from "../../UnorderedLists"
import CheckMark from "../../../../images/home/check.svg"
import IconHeadingTitle from "../../IconHeadingTitle"
import powerfulActionsData from "../../../../data/pageSections/platform/automation/powerfulActions"

const PowerfulActions = () => {
  const {
    titleIcon,
    title,
    description,
    graphic,
    imageLeft,
    benefits,
    tint,
    textLong,
  } = powerfulActionsData

  return (
    <CustomSection tint={tint}>
      <Container>
        <TextWrapper imageLeft={imageLeft} long={textLong}>
          <IconHeadingTitle icon={titleIcon} title={title} />
          {description}
          <UnorderedList>
            {benefits &&
              benefits.map(({ benefitName }) => (
                <ListItem>
                  <img
                    className="margin-right-10"
                    src={CheckMark}
                    alt="check"
                    title="check"
                  />
                  {benefitName}
                </ListItem>
              ))}
          </UnorderedList>
        </TextWrapper>
        <ImageWrapper
          imageLeft={imageLeft}
          short={textLong}
          className="powerful-image"
        >
          {graphic}
        </ImageWrapper>
      </Container>
    </CustomSection>
  )
}

export default PowerfulActions

const CustomSection = styled(Section)`
  ${Container} {
    padding: 60px 20px 40px;
  }
  ${({ theme }) => theme.se`
    padding-top: 0px;
    padding-bottom: 0px;
  `};
  ${({ theme }) => theme.desktop`
   .powerful-image .powerful-action-image img {
    object-fit: contain !important;
  }
  .powerful-image .powerful-action-image {
    height: 450px;
  }
  `};
`
